<script>
import { CSAT_RATINGS } from 'shared/constants/messages';
import FilterChip from './FilterChip.vue';

export default {
  name: 'ReportFiltersRatings',
  components: { FilterChip },
  emits: ['ratingFilterSelection'],
  data() {
    const translatedOptions = CSAT_RATINGS.reverse().map(option => ({
      ...option,
      label: this.$t(option.translationKey),
    }));

    return {
      selectedOption: null,
      options: translatedOptions,
    };
  },
  methods: {
    handleInput(selectedRating) {
      this.$emit('ratingFilterSelection', selectedRating);
    },
  },
};
</script>

<template>
  <FilterChip
    v-model="selectedOption"
    :options="options"
    label-key="label"
    track-key="value"
    :placeholder="$t('FORMS.MULTISELECT.SELECT_ONE')"
    icon="i-lucide-star"
    @update:model-value="handleInput"
  />
</template>
